import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { manageAES } from '@helpers';
import { environment } from '@environments/environment';

import packageInfo from '../../../package.json';

@Injectable({
  providedIn: 'root',
})
export class UrlShortenerService {
  public version: string;

  constructor(private http: HttpClient) {
    this.version = packageInfo.version;
  }

  private get apiUrl(): string {
    const base = environment.narobial_url.startsWith('http') ? environment.narobial_url : `https://${environment.narobial_url}`;
    return `${base}/api/urlreduce/acortaurlnarobial`;
  }

  getVersion(): string {
    return this.version;
  }

  generateToken() {
    const gmtString = new Date().getTime().toString();
    return manageAES(gmtString, 'encrypt').toString();
  }

  /**
   * Acorta una URL utilizando el servicio del backend
   * @param url La URL larga que deseas acortar
   * @returns Observable con la respuesta del servidor
   */

  shortenUrl(url: string): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post(this.apiUrl, { url: url }, { headers, responseType: 'text' });
  }
}
